import React, { useState, useEffect } from "react";
import { object, array, string } from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";
import { useMediaQuery } from "react-responsive";

import Row1 from "./Row1";
import Row2 from "./Row2";
import Column from "./Column";
import { getSlug } from "../../utils/utils";
import CollectionTitleWithArrow from "../../atoms/CollectionTitleWithArrow";
import DfpAd from "../../dfp-ad";

import "./fourteenStories3Ad1Widget.m.css";

const FourteenStories3Ad1Widget = ({ collection, sections, publisherAttributes, liveBlogStory, domainSlug }) => {
  const stories = collection.items.length > 0 && collection.items.filter(item => item.type === "story");
  const [row2Stories, setRow2Stories] = useState(stories.length > 2 ? stories.slice(2, 11) : null);
  const row1Stories = stories.slice(0, 2);
  const columnStories = stories.slice(11, 15);
  const collectionSlug = getSlug(collection, sections, domainSlug);
  const showCollectionName = get(collection, ["associated-metadata", "show_collection_name_website"], null);
  const widgetUrl = get(collection, ["associated-metadata", "widget_url"], null);
  const isDesktop = useMediaQuery({
    query: "(min-device-width: 1264px)"
  });

  useEffect(() => {
    !isDesktop && setRow2Stories(stories.length > 1 ? stories.slice(1, 14) : null);
  }, []);

  return stories.length > 1 ? (
    <div styleName="base" className="fourteen-stories-3ad-1widget">
      {showCollectionName && (
        <CollectionTitleWithArrow collectionSlug={collectionSlug} collectionName={collection.name} updatedFont={true} />
      )}
      <div styleName="wrapper">
        <div>
          {row1Stories.length > 0 && (
            <Row1
              stories={row1Stories}
              widgetUrl={widgetUrl}
              collectionSlug={collectionSlug}
              publisherAttributes={publisherAttributes}
              updatedFont={true}
              liveBlogStory={liveBlogStory}
            />
          )}
          {stories.length > 2 && (
            <Row2
              stories={row2Stories}
              updatedFont={true}
              publisherLang={publisherAttributes.lang}
              src="fourteen-stories-3ad-1-widget"
              liveBlogStory={liveBlogStory}
            />
          )}
        </div>
        <Column
          stories={columnStories}
          collectionSlug={collectionSlug}
          publisherAttributes={publisherAttributes}
          updatedFont={true}
          src="fourteen-stories-3ad-1-widget"
        />
      </div>
      <div styleName="ad-slot">
        <DfpAd
          adtype={publisherAttributes.lang === "en" ? "EnPalo_HP_468x60_B1" : "Home_468x60_B1"}
          collectionSlug={collectionSlug}
          layoutName="FourteenStories3Ad1Widget"
        />
      </div>
    </div>
  ) : null;
};

FourteenStories3Ad1Widget.propTypes = {
  collection: object.isRequired,
  sections: array,
  publisherAttributes: object,
  liveBlogStory: object,
  domainSlug: string
};

const mapStateToProps = state => {
  return {
    sections: get(state, ["qt", "config", "sections"], []),
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
    domainSlug: get(state, ["qt", "config", "domainSlug"], "")
  };
};

export default connect(mapStateToProps)(FourteenStories3Ad1Widget);
